<template>
    <div class="header" :class="{border: border, short: short}">
        <div class="activity" v-if="false">
            <img src="/static/img/gonggao.png" class="icon"/>
            <span class="word">超值福利：免费领取1000场视频面试</span>
            <span class="blue-word" @click="toFree">查看详情</span>
            <span class="xxx" @click="closeActivity"></span>
        </div>
        <div class="logo" :class="{short: short}">
            <!-- logo优先级比showLogo优先级高 -->
            <div class="left" v-if="logo">
                <img :src="logo" alt="" @click="toLogoLink">
                <span class="route-t">视频面试</span>
            </div>
            <div class="left active" v-else-if="showLogo">
                <img :src="showLogo" alt="" @click="toCompany">
                <span class="route-t" v-if="showLogo != '/static/img/logo.png'">视频面试</span>
            </div>
            <div class="left active" v-else>
                <img src="/static/img/hina-logo.png" alt="" @click="toCompany">
                <span class="route-t" v-if="fr === 'aihome'">AI面试</span>
                <span class="route-t" v-else-if="show">视频面试</span>
                <span class="route-t"></span>
            </div>
            <div class="right">
                <el-button type="text" style="font-size:15px;margin-right: 0px;" @click="gotoExam(fr)" class="btn" v-if="!hideAll && !showThree && (company.id !== '80925') ">
                    <span class="flex link left-button ai-header">
                        在线笔试
                    </span>
                </el-button>
                <el-button type="text" style="font-size:15px;margin-right: 0px;" @click="gotoInterview(fr)" class="btn" v-if="!hideAll && !showThree">
                    <span v-if="fr === 'aihome'" class="flex link left-button ai-header" style="margin-left: 10px;">
                        视频面试
                    </span>
                    <span v-else class="flex link left-button ai-header">
                        AI面试
                    </span>
                </el-button>
                <el-button type="text" style="font-size:15px;margin-right: 0px;" @click="gotoHire" class="btn" v-if="!hideAll && !showThree">
                    <span class="flex link left-button ai-header">
                        招聘系统
                    </span>
                </el-button>
                <el-button type="text" style="font-size:15px;" @click="contactUs" class="btn" v-if="!hideAll && !showThree">
                    <span class="flex link ai-header" style="cursor: default;">
                       400-789-0789
                    </span>
                </el-button>
                <el-button type="text" class="btn-spe" v-if="!hideAll && !showThree" size="small" style="margin-left: 0px;">
                    <span class="flex link ai-header" @click="toAccount">
                       <span style="cursor: pointer;font-size: 14px;color:#3e444c; ">剩余额度：{{count}}</span>
                       <!-- <span class="blue" @click="toAccount">详情</span> -->
                    </span>
                </el-button>
                <el-button type="text" class="btn" @click="toTest" v-if="showThree">
                    <span class="flex link ai-header">
                       设备检测
                    </span>
                </el-button>
<!--                <a class="link" target="blank" :href="helpUrl" @click="log('clickHelp', `点击最上方的“帮助中心”`)" style="margin-right: 20px" v-if="!hideAll">帮助中心</a>-->
              <!-- <a class="link ai-header" target="blank"  @click="showHelp=true" style="margin-right: 20px" v-if="!hideAll">帮助中心</a> -->
                <el-button class="ai-header" type="primary" plain round size="mini" style="margin-right: 20px"  @click="showModal" v-if="showThree">使用手机端</el-button>
                <el-dropdown class="avatar" placement="bottom" @command="command" trigger="click" v-if="user && user.id && company && company.id">
                    <span class="el-dropdown-link" style="cursor: pointer;user-select:none" @click="setLocalStorageInfo('company')">
                        <el-badge :is-dot="!(clicked && clicked['company'])" class="left-idot"><span class="limit ai-header">{{company && company.name}}</span><i class="el-icon-arrow-down el-icon--right"></i></el-badge>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="setting">
                        <div class="nickname" v-if="user.nickname || user.mobile || (user.wechatInfo && user.wechatInfo.nickname)">{{user.nickname || user.mobile || (user.wechatInfo && user.wechatInfo.nickname)}}</div>
                        <!-- <div class="info" v-if="company && company.id">
                            <p class="title">当前公司：</p>
                            <div class="content">
                                <div class="single" style="height: auto">{{company && company.name}}</div>
                            </div>
                        </div> -->
                        <div class="info handle" v-if="companyList.length > 1">
                            <p class="title" style="margin-bottom: 10px">我的公司</p>
                            <div class="content">
                                <div class="single" style="color: #5272FF;cursor: default;" v-for="(item, index) in companyList" @click="selectCompany(item)" v-if="item.id == company.id"><span class="text-ellipsis-hidden">{{item.name}}</span><span class="current-single">当前</span></div>
                                <div class="single" v-for="(item, index) in companyList" @click="selectCompany(item)" v-if="item.id != company.id">{{item.name}}</div>
                            </div>
                        </div>
                        <el-divider v-if="company && (company.role == '2' || company.role == '1')"></el-divider>
                        <div class="info handle" v-if="company && (company.role == '2' || company.role == '1')">
                            <p class="title" style="margin-bottom: 10px">管理员</p>
                            <div class="content">
                                <div class="single" @click="toManage">管理团队</div>
                                <el-badge :is-dot="!(clicked && clicked['invite'])" class="left-idot idot-6"><div class="single" @click="toInvite();setLocalStorageInfo('invite')" style="width: 100%">邀请成员</div></el-badge>
                            </div>
                        </div>
                        <el-divider class="divider"></el-divider>
                        <el-dropdown-item  command="manage" class="bottom-block">
                            <i class="el-icon-user" style="margin-right: 10px;color: #5272FF;"></i>
                            个人中心
                        </el-dropdown-item>
                        <el-dropdown-item  command="helpmodel" class="bottom-block">
                            <i class="el-icon-service" style="margin-right: 10px;color: #5272FF;"></i>
                            帮助中心
                        </el-dropdown-item>
                        <el-dropdown-item  command="create" class="bottom-block">
                            <i class="el-icon-plus" style="margin-right: 10px;color: #5272FF;"></i>
                            创建新公司
                        </el-dropdown-item>
                        <el-dropdown-item  command="logout" class="bottom-block">
                            <i class="el-icon-warning-outline" style="margin-right: 10px;color: #5272FF;"></i>
                            退出登录
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <ToMpModal ref="toMpModal" :code="code"></ToMpModal>
        <el-dialog :visible.sync="showContact" title="联系我们" width="500px">
            <div style="display:flex;flex-direction:column;align-items:center">
                <strong>扫码添加您的专属客服微信，24小时响应您遇到的问题</strong>
                <img src="/static/img/service-logo.png" alt="" class="logo" style="width:auto;height:200px">
            </div>
        </el-dialog>
      <el-dialog :visible.sync="showHelp" title="帮助中心" width="800px" style="padding: 20px">
        <h4 style="margin-top: 0">
          1.请先确认是否做过设备调试，如果没有，请先调试设备，设备调试链接：<a href="http://vi.hinapower.com/device-test" target="_blank">http://vi.hinapower.com/device-test</a>。
        </h4>
        <h4>2.如果设备调试正常，请按照以下方式解决问题。</h4>
        <div style="background: #F6F8FF;padding: 20px">
          <p class="question" style="margin-top: 0">问题：视频卡顿、模糊，声音断断续续等。</p>
          <p>
            请先检查自己的网络，如果网络较差，可更换网络或使用手机面试（微信搜索小程序「海纳面试」或下载「海纳视频面试」App）。
            也可以尝试关闭视频画面，只通过语音通话。
          </p>
          <p class="question">问题：无法看到对方画面。</p>
          <p>
            请先检查是否对方关闭了视频画面。
            若对方未关闭，可尝试双方刷新重进一下。面试官可尝试右下角更多里选择「一键修复」。
          </p>
          <p class="question">问题：无法听见对方的声音。</p>
          <p>1. 确认自己的电脑音量外放足够大，以及自己的网络是否通畅。</p>
          <p>2. 提示对方，让对方确认对方的麦克风是否正常，可以正常录声音。可提示对方做设备调试。</p>
          <p>3. 可尝试双方刷新重进一下。面试官可尝试右下角更多里选择「一键修复」。</p>
          <p class="question">问题：对方无法听到我的声音。</p>
          <p>1. 确认自己的麦克风是否正常，是否可正常录声音。可重做设备调试。</p>
          <p>2. 提示对方，让对方确认对方的音量外放足够大，可以正常播放声音。可提示对方做设备调试。</p>
          <p>3. 可尝试双方刷新重进一下。面试官可尝试右下角更多里选择「一键修复」。</p>
          <p class="question">问题：有噪声或回声。</p>
          <p>1. 如果您旁边有其他人进入，或者同时使用电脑和手机进入，请只保留一个接入。</p>
          <p>2. 您也可以尝试戴耳机（带有耳麦）接入。</p>
          <p>3. 可尝试刷新重进一下。面试官可尝试右下角更多里选择「一键修复」。</p>
          <p class="question">问题：一直进不了面试。</p>
          <p>1. 请尝试重新做设备调试，并检查您的网络是否通畅。</p>
          <p>2. 请确保您授权了摄像头和麦克风权限。</p>
        </div>
        <h4>3.若以上方式均不能解决您的问题，可以联系海纳的技术支持团队，联系方式如下：</h4>
        <div style="background: #F6F8FF;padding: 20px">
          <p>在线客服：<a href="https://hinapower.udesk.cn/im_client/" target="_blank">在线客服</a>（工作日9:00-20:00）</p>
          <p>微信客服：可添加微信号（工作日9:00-20:00，周六日10:00-19:00）</p>
          <p>
            <img style="width:200px;height:200px;"
                 src="https://oss.hinapower.cn/cdn/app/hina/static/image/kfbarcode-new.png"></img>
          </p>
        </div>
      </el-dialog>
    </div>
</template>
<script>
    import toolkit from '@/util/toolkit'
    import config from "@/util/config";
    import ToMpModal from '@/components/ToMpModal'
    import {eventBus} from '@/eventBus'
    import {mapState} from 'vuex'
    export default {
        components: {
            ToMpModal
        },
        props: {
            code: {
                type: String,
                default: ''
            },
            queueLogo: {
                type: String,
                default: ''
            },
            border: {
                type: Boolean,
                default: false
            },
            // 隐藏设备检测后进入面试的入口
            hideTestEntry: {
                type: Boolean,
                default: false
            },
            // 1200px
            short: {
                type: Boolean,
                default: false
            },
            noActivity: {
                type: Boolean,
                default: false
            },
            // 全隐藏
            hideAll: {
                type: Boolean,
                default: false
            },
            // 三个
            showThree: {
                type: Boolean,
                default: false
            },
            // 来源，是否冲AI面试官网过来
            fr: {
                type: String,
                default: ''
            }
        },
        data(){
            return{
                show: false,
                helpUrl: config.helpUrl,
                showContact: false,
                showHelp: false,
                // 低优先级
                showLogo: "",
                link: "",

                // 高优先级
                logoLink: "",
                logo: "",

                clicked: {},
                showActivity: true,
                count: 0,
                user: {},
                hideMobile: false
            }
        },
        mounted(){
            this.showActivity = localStorage.getItem('showActivity')
            if (this.showActivity != 'false') {
                this.showActivity = true
            } else {
                this.showActivity = false
            }
            this.refreshSource()
            this.user = this.userInfo ? this.userInfo : {}
            if(this.user && this.user.id){
                this.show = true
            }
            if(this.isAdmin){
                toolkit.getCompanyList().then(() => {
                    this.getCount()
                })
            }

            this.getLogo()
            this.onShowLogo()
            this.getLocalStorageInfo()
            eventBus.$on("hide-mobile",()=>{ // 部分页面需要隐藏使用手机端的按钮
                this.hideMobile = true
            })
        },
        computed: {
            ...mapState(['userInfo', 'source', 'company', 'companyList']),
            isAdmin(){
                return this.$route.meta.needToken && this.$route.meta.needCompany
            },
            notLimitResource(){
                // 默认true,当userInfo中的source命中对应source时返回false
                if(this.userInfo.userConfig && this.userInfo.userConfig.source === 'szhr'){
                    return false
                }else{
                    return true
                }
            }
        },
        methods: {
            getCount() {
                toolkit.post(config.companyHost + '/api/stock/count', {
                    companyId: toolkit.getCompany()
                }).then(res => {
                    if (res.code == 0) {
                        this.count = res.data.list[0].remain
                    } else {
                        this.$message.error(res.message);
                    }
                }).catch(e => {
                    console.log(e)
                })
            },
            closeActivity() {
                this.showActivity = false
                localStorage.setItem('showActivity', false)
            },
            toAccount() {
                // 跳account
                window.open(config.companyHost + '/#/trade?companyId=' + toolkit.getCompany())
            },
            toFree() {
                // 领取
                window.open("https://mp.weixin.qq.com/s/Y6eJNcOQFmrC3O6oS_D6Tg")
            },
            gotoHire(){
                this.log('clickToHire', `点击招聘系统`)
                window.open('https://hr.hinapower.cn/', '_blank')
            },
            gotoInterview(fr){
                if (fr === 'aihome') {
                    window.open(config.interviewHost + '/content', '_blank')
                } else {
                    window.open(config.aiInterviewHost)
                }
                
            },
            gotoExam(fr) {
                window.open(config.viBakHost + '/exam/paper?back=7', '_blank')
            },
            onShowLogo(){
                // 通过链接码获取的公司Logo（面向非登录态用户s）
                eventBus.$on("show-logo", (res)=>{
                    // logo优先级：公司 -》个人信息配置
                    if(res.companyInfo && res.companyInfo.logoUrl){
                        this.logo = res.companyInfo.logoUrl
                    }else if(res.userConfig && res.userConfig.specialLogoOss){
                        this.logo = res.userConfig.specialLogoOss
                        if (res.userConfig.jumpUrl) {
                            this.logoLink = res.userConfig.jumpUrl
                        } else {
                            this.$router.push('/ai-login')
                        }
                        
                    }
                })
            },
            refreshSource(){
                let s = this.$route.query.source
                switch(s){
                    case 'leaderhr':
                    s = 'linghang'
                    break;
                    case 'pxrc':
                    s = 'pxrc'
                    break;
                }
                let source = s || window.localStorage.getItem("login-source")
                if(source){
                    window.localStorage.setItem("login-source", source)
                    this.$store.commit("updateSource", source)
                }
            },
            showModal(){
                this.$refs['toMpModal'].show()
                this.log('clickMp', `点击最上方的“体验小程序”`)
            },
            contactUs(){
                this.log('clickContactUs', `点击联系我们`)
                // this.showContact = true
            },
            command(e){
                let that = this
                let map = {
                    'logout': function (){
                        that.logout()
                    },
                    'create': function(){
                        that.toCreateCompany()
                    },
                    'manage': function(){
                        that.toPersonal()
                    },
                    'helpmodel': function() {
                        that.showHelpModel()
                    }
                }
                map[e]()
            },
            logout(){
                toolkit.logout()
                this.$router.replace('/')
                //console.log(this.$route, 'rrr')
            },
            toHome(){
                this.$router.push('/content')
            },
            log(action, info, extraData){
                return toolkit.logToBackend(action,info, extraData)
            },
            toTest(){
                this.log('点击导航栏的“设备检测”按钮')
                if(this.hideTestEntry){ // 是否携带参数去设备检测
                    this.$router.push({
                        name: "device-test"
                    })
                }else{
                    this.$router.push({
                        name: "device-test",
                        query: this.$route.query
                    })
                }
            },
            async getLogo(){
                setTimeout(() => {
                    if(this.queueLogo) {
                        this.showLogo = this.queueLogo
                    }
                },200)
                if(this.user && this.user.id){ // 已登录
                    this.showLogo = this.company && this.company.logoUrl || this.user.userConfig.specialLogoOss || '/static/img/logo.png' // 从用户表里取
                    this.link = this.user.userConfig.jumpUrl
                }else if(this.$route.query.source){ // 未登录，有source
                    let sourceInfo = await this.getSourceLogo(this.$route.query.source)
                    this.showLogo = sourceInfo.logoUrl
                    this.link = sourceInfo.jumpUrl
                }else {
                    this.link = '/ai-login'
                    this.showLogo = '/static/img/hina-logo.png' // 默认hina logo
                }
            },
            getSourceLogo(source){
                return toolkit.post("/interview/info/sourceConfig", {
                    source: source
                }).then(res => {
                    if(res.code == 0){
                        return res.data
                    }else{
                        return {
                            logoUrl: '/static/img/logo.png',
                            jumpUrl: '/ai-login'
                        }
                    }
                }).catch(e => {
                    return {
                        logoUrl: '/static/img/logo.png',
                        jumpUrl: '/ai-login'
                    }
                })
            },
            toCompany(){
                window.location.href = this.link
            },
            toLogoLink(){
                if(this.logoLink){
                    window.location.href = this.logoLink
                }else{
                    // this.toHome()
                    this.$router.push('/ai-login')
                }
            },
            toCreateCompany(){
                window.open(config.companyHost + '/#/create')
            },
            toManage(){
                window.open(config.companyHost + '/#/info?companyId=' + this.company.id)
            },
            toPersonal(){
                window.open(config.companyHost + '/#/user?companyId=' + this.company.id)
            },
            showHelpModel() {
                this.showHelp = true
            },
            toInvite(){
                window.open(config.companyHost + '/#/member?companyId=' + this.company.id)
            },
            selectCompany(item){
                toolkit.setCompany(item.id)
                this.fullLoading()
                toolkit.refreshCompanyInfo().then(()=>{
                    window.location.reload()
                })
            },
            fullLoading(){
                const loading = this.$loading({
                    lock: true,
                    text: '正在切换团队...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                    this.$message.error("切换团队超时")
                }, 10000);
            },
            getLocalStorageInfo(){
                this.clicked = JSON.parse(window.localStorage.getItem("new-hiner")|| "{}")
            },
            setLocalStorageInfo(item){
                this.clicked[item] = 1
                this.$forceUpdate()
                window.localStorage.setItem("new-hiner", JSON.stringify(this.clicked))
            }
        }
    }
</script>
<style scoped lang="scss">
.text-ellipsis-hidden {
    max-width: 107PX;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.ai-header {
    font-weight: 500;
    font-size: 14px !important;
    color: #3e444c !important;
}
.btn-spe {
    // width:156px;
    width: auto;
    // height:32px;
    // background:rgba(255,250,235,1);
    border-radius:4px;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: default;
    font-size: 14px;
}
p{
    margin: 4px 0;
}
    >>>.el-divider--horizontal {
        margin: 20px 0;
        margin-top: 0;
    }
    .bottom-block {
        height: 50px;
        display: flex;
        align-items: center;
    }
    .header{
        box-shadow:0 0 0 0 rgba(0,0,0,0.1);
        &.border{
            border-bottom: $Border;
        }
        &.short {
            display: flex;
            justify-content: center;
        }
    }
    .header .logo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 50px;
        padding-bottom: 0;
        height: 54px;
        box-sizing: border-box;
        box-shadow: 0px 0px 0px 2px #f6f6f6;
        // margin-bottom: 20px;
        &.short{
            width: 1230px;
            padding: 0;
            // padding-left: 20px;;
            margin-left: 40px;
            box-shadow: none;
        }
        .link{
            text-decoration: none;
            color: #5272FF;
            font-size: 15px;
            cursor: pointer;
            &:hover{
                color: #627FFF;
            }
        }
        .left-button {
            font-size: 14px;
            color: #3E444C;
        }
    }
    .header .logo .left img {
        height: 30px;
        width: auto;
    }
    .header .logo .left .title {
        font-size: 20px;
        color: #333;
        font-weight: bold;
        .l1{
            margin: 0 6px;
        }
    }
    .header .logo .left {
        display: flex;
        align-items: center;
        &.active{
            cursor: pointer;
        }
        .route-t{
            white-space: nowrap;
            font-size: 18px;
            margin-left: 10px;
        }
    }
    .header .right {
        display: flex;
        align-items: center;
        .right-btn{
            color: #fff;
            background-color: #5272ff;
            border-radius: 20px;
            border: 1px solid;
            padding: 4px 20px;
            margin-left: auto;
            cursor: pointer;
            font-size: 15px;
            transition: all 0.1s ease;
            font-weight: bold;
            margin: 0 20px;
            &:hover {
                color: #5272ff;
                background-color: #fff;
            }
        }
        .btn{
            font-size: 15px;
            margin: 0 20px;
            .flex{
                display: flex;
                align-items: center;
            }
            img{
                width: 15px;
                height: 15px;
                margin: 0 4px;
            }
        }
        .link{
            font-size: 13px;
            color: $SubColor;
        }
        .use-mobile{
            width: 120px;
            height: 32px;
            margin: 0 24px;
            border-radius: 16px;
            @include plainBtn;
            font-size: 13px;
            font-weight: 400;
            color: rgba(82,114,255,1);
        }
        .blue {
            margin-left: 10px;
            cursor: pointer;
            color: #5272FF;
            &:hover{
                color: #627FFF;
            }
        }
    }

    .header .avatar{
        // margin-top: 4px;
        span{
            @include flexRow;
        }
        .limit{
            font-size: 15px;
            @include Ellipsis;
            max-width: 400px;
            display: inline-block;
        }
    }
    .el-dropdown-menu{
        width: 200px;
        padding: 0 !important;
    }
    .setting{
        .nickname{
            background:#F6F8FF;
            border-radius:4px 4px 0 0;
            padding: 20px;
            margin-bottom: 10px;
            font-size: 14px;
            display: flex;
            align-items: center;
            // border-bottom: 1px solid #ededed;
        }
        .info{
            margin: 10px 0;
            user-select: none;
            .title{
                font-size: 13px;
                color: $c2;
                margin-left: 20px;
                margin-top: 20px;
                margin-bottom: 20px;
            }
            .content{
                max-height: 300px;
                overflow: auto;
                .single{
                    padding-left: 30px;
                    font-size: 13px;
                    color: $c1;
                    height: 40px;
                    @include flexRow;
                    justify-content: flex-start;
                }
                .current-single {
                    margin-left: 5px;
                    width: 28px;
                    height: 16px;
                    background: #5272FF;
                    border-radius: 2px;

                    font-size: 10px;
                    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                    font-weight: 400;
                    color: #FFFFFF;
                    // line-height: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            &.handle{
                .content{
                    .single{
                        cursor: pointer;
                        &:hover{
                            color: $Primary;
                            background: #FBFBFF;
                        }
                    }
                }
            }
        }
        .divider{
            margin: 0 !important;
            // margin-bottom: 5px !important;
        }
    }
    @media (max-width: 900px) {
        .header {
            .right{
                display: none;
            }
            .logo{
                padding: 10px 20px;
            }
        }
    }

/deep/.left-idot{
    @include flexRow;
    .el-badge__content.is-fixed.is-dot{
        left: -10px;
        top: 50%;
        transform: translate(0, -50%);
    }
    &.idot-6{
        .el-badge__content.is-fixed.is-dot{
            left: 6px;
        }
    }
}
.activity {
    background: #EFF2FF;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    .word {
        font-size:16px;
        // font-family:SourceHanSansCN-Medium,SourceHanSansCN;
        font-weight:bold;
        color:rgba(62,68,76,1);
    }
    .icon {
        margin-right: 10px;
        width: 26px;
        height: 18px;
    }
    .blue-word {
        font-size:16px;
        // font-family:SourceHanSansCN-Regular,SourceHanSansCN;
        font-weight:400;
        color:rgba(82,114,255,1);
        margin-left: 10px;
        cursor: pointer;
    }
    .xxx {
        right: 20px;
        position: absolute;
        cursor: pointer;
        background-image: url('../../static/img/xxx.png');
        width: 24px;
        height: 24px;
    }
    .xxx:hover {
        background-image: url('../../static/img/xxx-hover.png');
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AiHeader.vue